import { SVGProps } from 'react';

const IcFail = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='48' height='48' viewBox='0 0 48 48' fill='none' {...props}>
      <g clip-path='url(#clip0_24181_4118)'>
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M24.0271 20.4023C25.9912 20.4023 27.9688 21.7513 27.9688 23.4153V37.4758C27.9688 39.1397 25.9438 40.4887 23.9797 40.4887C22.0155 40.4887 20.0083 39.1397 20.0083 37.4758V23.4153C20.0083 21.7513 22.063 20.4023 24.0271 20.4023ZM23.9797 9.51172C21.3607 9.51172 20.0081 11.3103 20.0081 13.529C20.0081 15.7477 21.3607 17.5463 23.9797 17.5463H24.0271C26.6461 17.5463 27.9688 15.7477 27.9688 13.529C27.9688 11.3103 26.6461 9.51172 24.0271 9.51172H23.9797Z'
          fill={props.fill || '#1D2129'}
        />
        <path
          d='M44.5996 24C44.5996 12.6229 35.3771 3.40039 24 3.40039C12.6229 3.40039 3.40039 12.6229 3.40039 24C3.40039 35.3771 12.6229 44.5996 24 44.5996V48C10.7452 48 0 37.2548 0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48V44.5996C35.3771 44.5996 44.5996 35.3771 44.5996 24Z'
          fill={props.fill || '#1D2129'}
        />
      </g>
      <defs>
        <clipPath id='clip0_24181_4118'>
          <rect width='48' height='48' rx='24' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

export default IcFail;
